import React, { Suspense, lazy } from 'react';
import { Helmet } from 'react-helmet-async';

// Import the HeroSection directly (without lazy loading)
import HeroSection from "../components/HeroSection";

// Lazy load other components bruh
const InfrastructureSection = lazy(() => import("../components/Infrastructure"));
const GameSolutions = lazy(() => import("../components/GameSolutions"));
const GlobalLocations = lazy(() => import("../components/GlobalLocations"));
const EnterpriseSupport = lazy(() => import("../components/EnterpriseSupport"));

const HomePage = () => {
    return (
        <>
            <Helmet>
                <title>Creart Cloud - Hosting ve Sunucu Hizmetleri</title>
                <meta
                    name="description"
                    content="Creart Cloud ile premium VDS, Dedicated Sunucu ve Web Hosting hizmetleri! AMD Ryzen 9950X ve Intel Xeon işlemciler, NVMe SSD, DDoS koruması ve 7/24 uzman destek ile ultra hızlı, güvenli sunucular. Uygun fiyatlarla hemen başlayın!"
                />
                <meta
                    name="keywords"
                    content="Creart Cloud, İstanbul hosting, VDS, Dedicated Sunucu, Web Hosting, premium hosting, AMD Ryzen 9950X VDS, Intel Xeon sunucu, NVMe SSD hosting, DDoS korumalı hosting, 7/24 destek hosting, uygun fiyatlı VDS, İstanbul veri merkezi, kurumsal hosting, Tier III veri merkezi, güvenli sunucu, VDS kiralama, ultra hızlı hosting, Dedicated hosting İstanbul, Creart Cloud İstanbul"
                />
                <meta name="robots" content="index, follow" />
                <meta name="author" content="Creart Cloud" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0" />
                <meta name="language" content="tr-TR" />
                <link rel="canonical" href="https://creartcloud.com" />

                {/* Open Graph Meta Tags */}
                <meta property="og:title" content="Creart Cloud - Premium Hosting ve Sunucu Hizmetleri" />
                <meta
                    property="og:description"
                    content="Creart Cloud premium VDS, Dedicated Sunucu ve Web Hosting hizmetleri: AMD Ryzen, Intel Xeon, NVMe SSD, DDoS koruması ve 7/24 destek. Uygun fiyatlarla ultra hızlı ve güvenli sunucularınızı hemen kurun!"
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://creartcloud.com" />
                <meta property="og:site_name" content="Creart Cloud" />
                <meta property="og:image" content="https://cdn.creartcloud.com/posts/og-homepage.png" />
                <meta property="og:image:alt" content="Creart Cloud Hosting ve Sunucu Hizmetleri" />
                <meta property="og:locale" content="tr_TR" />

                {/* Twitter Card Meta Tags */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Creart Cloud - Hosting ve Sunucu Hizmetleri" />
                <meta
                    name="twitter:description"
                    content="Creart Cloud ile VDS, Dedicated Sunucu ve Web Hosting: AMD Ryzen 9950X, Intel Xeon, NVMe SSD, DDoS koruması ve 7/24 destek. Uygun fiyatlarla ultra hızlı sunucular!"
                />
                <meta name="twitter:image" content="https://cdn.creartcloud.com/posts/og-homepage.png" />
                <meta name="twitter:image:alt" content="Creart Cloud Hosting" />
                <meta name="twitter:site" content="@CreartCloud" />

                {/* Schema.org Structured Data */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "WebSite",
                        "name": "Creart Cloud",
                        "url": "https://creartcloud.com",
                        "description": "Creart Cloud, premium VDS, Dedicated Sunucu ve Web Hosting hizmetleri sunar. AMD Ryzen 9950X ve Intel Xeon işlemciler, NVMe SSD, DDoS koruması ve 7/24 teknik destek ile ultra hızlı ve güvenli sunucular.",
                        "publisher": {
                            "@type": "Organization",
                            "name": "Creart Cloud",
                            "url": "https://creartcloud.com",
                            "logo": {
                                "@type": "ImageObject",
                                "url": "https://cdn.creartcloud.com/logo/logo.png"
                            }
                        },
                        "potentialAction": {
                            "@type": "SearchAction",
                            "target": "https://creartcloud.com/search?q={search_term_string}",
                            "query-input": "required name=search_term_string"
                        },
                        "offers": {
                            "@type": "Offer",
                            "priceCurrency": "TRY",
                            "price": "180.00",
                            "url": "https://creartcloud.com/vds"
                        }
                    })}
                </script>
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        "name": "Creart Cloud",
                        "url": "https://creartcloud.com",
                        "logo": "https://cdn.creartcloud.com/logo/logo.png"
                    })}
                </script>
            </Helmet>
            {/* Renders the HeroSection now */}
            <HeroSection />
            {/* Wrap lazy components in Suspense :) */}
            <Suspense fallback={null}> {/* Use null to show nothing during loading */}
                <InfrastructureSection />
                <GameSolutions />
                <GlobalLocations />
                <EnterpriseSupport />
            </Suspense>
        </>
    );
};

export default HomePage;
